var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        width: 80,
        "footer-hide": true,
        title: "备用库入库单详情",
        "class-name": "vertical-center-modal",
      },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.innerSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Form",
                    {
                      ref: "warehouseForwardEntryFrom",
                      staticClass: "small-form",
                      attrs: { "label-position": "top" },
                    },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "单号" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.warehouseForwardEntryFrom.record
                                          .warehouseForwardEntryRecordBillCode,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "批次" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.warehouseForwardEntryFrom.record
                                          .warehouseForwardEntryRecordBatchCode,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "项目" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.warehouseForwardEntryFrom.record
                                          .warehouseForwardEntryRecordProject,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "电话" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.warehouseForwardEntryFrom.record
                                          .warehouseForwardEntryRecordContactNumber,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "制单时间" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.formatWarehouseForwardEntryRecordCreateAt,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "制单人" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.warehouseForwardEntryFrom.ownerName,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Card",
                    {
                      staticClass: "thin-card-title",
                      attrs: { padding: 0, bordered: false, "dis-hover": true },
                    },
                    [
                      _c("p", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v("入库产品"),
                      ]),
                      _c("Table", {
                        attrs: {
                          columns: _vm.entryTable.tableColumns,
                          size: "small",
                          data: _vm.warehouseForwardEntryFrom.details,
                          border: true,
                          stripe: true,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }